<swiper [config]="swiperConfigService.swiperFilhoConfig">
    <div class="swiper-slide">
        <app-contato-page1></app-contato-page1>
    </div>
</swiper>